<div *transloco="let t" class="flex h-full flex-col gap-4">
  <div class="flex w-full justify-between">
    <div></div>
    <button
      iButton
      [disabled]="isReadOnly() || isTargetingCountReached()"
      (click)="createTargeting()"
      [iTooltip]="isTargetingCountReached() && t('sd-targeting.maximum_targetings_reached')"
      iTooltipPlacement="top-center"
    >
      <IIcon name="plus" />
      {{ t("sd-page.add_a_targeting") }}
    </button>
  </div>
  <div class="flex min-h-0 flex-1 flex-col pb-40">
    @if (hasTargetings()) {
      <table iTable class="w-full">
        <thead iTableHead>
          <tr class="w-full">
            <th class="w-1/2" iTableTh>{{ t("sd-targeting.table_targeting") }}</th>
            <th class="w-[20%]" iTableTh>{{ t("sd-targeting.table_type") }}</th>
            <th class="min-w-15 text-right" iTableTh></th>
          </tr>
        </thead>
        <tbody>
          @if (strategy(); as strategy) {
            @if (!strategy.disableOtherQueries) {
              <tr
                iTableRow
                class="group"
                app-sd-strategy-targeting-row
                [defaultTactic]="true"
                [strategy]="strategy"
                [isReadOnly]="isReadOnly()"
                [isLastTargeting]="isOnlyOneTargeting()"
                [organizationId]="organizationId()"
              ></tr>
            }
            @for (tactic of targetings(); track tactic.segmentId) {
              <tr
                iTableRow
                class="group"
                app-sd-strategy-targeting-row
                [tactic]="tactic"
                [strategy]="strategy"
                [isReadOnly]="isReadOnly()"
                [isLastTargeting]="isOnlyOneTargeting()"
                [organizationId]="organizationId()"
              ></tr>
            }
            @for (audience of audiences(); track audience.audienceTargetId) {
              <tr
                iTableRow
                class="group"
                app-sd-strategy-targeting-row
                [audience]="audience"
                [strategy]="strategy"
                [isReadOnly]="isReadOnly()"
                [isLastTargeting]="isOnlyOneTargeting()"
                [organizationId]="organizationId()"
              ></tr>
            }
          }
        </tbody>
      </table>
    } @else {
      <div class="flex h-full items-center justify-center">
        <IEmptyState
          [title]="t('sd-targeting.no_targetings')"
          [description]="t('sd-targeting.no_targetings_description')"
          ctaIcon="add"
          [ctaLabel]="t('sd-page.add_a_targeting')"
          [ctaDisabled]="isReadOnly() || isTargetingCountReached()"
          (ctaClick)="createTargeting()"
        />
      </div>
    }
  </div>
</div>
